export const AI_VISIBILITY_STEPS = [
  { key: 'brand', label: 'Brand' },
  { key: 'market', label: 'Market' },
  { key: 'category', label: 'Category' },
  { key: 'prompts', label: 'Prompts' },
  { key: 'review', label: 'Review' },
]

export const DEFAULT_MARKET = 'United States'
export const DEFAULT_LOCATION_CODE = 2840
export const DEFAULT_COUNTRY_ISO_CODE = 'US'
export const DEFAULT_LANGUAGE = 'English'
export const DEFAULT_LANGUAGE_CODE = 'en'

// Languages the Market step offers on top of the shared DataForSEO list (consts/dataforseo_languages.json).
// Regional variants live here only: the question generation needs the variant's own name and the Google
// SERP / AI Mode calls take its code, while the keyword research tools stay on DataForSEO Labs' base
// languages. `after` is the code of the shared-list entry the variant follows.
export const EXTRA_LANGUAGES = [
  { language_name: 'Brazilian Portuguese', language_code: 'pt-BR', after: 'pt' },
]

export const REFRESH_FREQUENCY_OPTIONS = [
  { value: 'weekly', label: 'Weekly', periodLabel: 'Week' },
  { value: 'monthly', label: 'Monthly', periodLabel: 'Month' },
  { value: 'once', label: 'Once', periodLabel: 'Once' },
]

export const EMPTY_SETUP_DRAFT = {
  brandName: '',
  websiteUrl: '',
  categories: [],
  market: DEFAULT_MARKET,
  locationCode: DEFAULT_LOCATION_CODE,
  countryIsoCode: DEFAULT_COUNTRY_ISO_CODE,
  language: DEFAULT_LANGUAGE,
  languageCode: DEFAULT_LANGUAGE_CODE,
  questionGroups: [],
  customQuestions: [],
  selectedQuestionIds: [],
  reviewQuestionIds: [],
  refreshFrequency: 'weekly',
}
